//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MZDialog',
  props: {
    btnColor: {
      type: String,
      required: false,
      default: ''
    },
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: '提醒'
    },
    btnText: {
      type: String,
      required: false,
      default: '确 定'
    },
    cancelTex: {
      type: String,
      required: false,
      default: '取 消'
    },
    type: {
      type: String,
      required: false,
      default: 'dialog'
    },
    isShowCloseIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    isShowBtn: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    dialogBtn () {
      this.$emit('dialogBtn')
    },
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/dialog/index.vue